import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../api/axios';
import socket from '../socket';

const BrandingContext = createContext();

export const BrandingProvider = ({ children }) => {
    // Hydrate from SSR data if available
    const initialBranding = (typeof window !== 'undefined' && window.__INITIAL_DATA__?.branding) || {
        tagline_en: 'Find Your Perfect Place',
        slogan_en: 'Discover your dream home in the heart of Sri Lanka.',
        hero_title_en: 'Your Next Home Starts Here',
        hero_subtitle_en: 'Trusted listings. Real opportunities. Seamless experience.',
        tagline_si: 'සිහින නිවසට නවීන ඩිජිටල් මාවත.',
        slogan_si: 'ශ්‍රී ලංකාවේ ප්‍රමුඛතම දේපල වෙළඳාම් ජාලය සමඟ එක්වන්න.',
        hero_title_si: 'ඔබේ ඊළඟ නිවහන මෙතැනින් ආරම්භ වේ',
        hero_subtitle_si: 'විශ්වාසදායී ලැයිස්තුගත කිරීම්. සැබෑ අවස්ථා.'
    };

    const [branding, setBranding] = useState(initialBranding);
    const [loading, setLoading] = useState(!(typeof window !== 'undefined' && window.__INITIAL_DATA__?.branding));
    const [currentLang, setCurrentLang] = useState(localStorage.getItem('lang') || 'en');

    const setLang = (lang) => {
        setCurrentLang(lang);
        localStorage.setItem('lang', lang);
    };

    const fetchBranding = async () => {
        try {
            const res = await API.get('/branding/settings');
            if (res.data) {
                setBranding(prev => ({ ...prev, ...res.data }));
            }
        } catch (error) {
            console.error('Failed to fetch branding settings:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBranding();

        // Listen for realtime branding updates
        socket.on('branding_update', (newSettings) => {
            console.log('[REALTIME_BRANDING] Received update:', newSettings);
            setBranding(prev => ({ ...prev, ...newSettings }));
        });

        return () => {
            socket.off('branding_update');
        };
    }, []);

    // Helper to get localized text
    const t = (key, lang = currentLang) => {
        const localizedKey = `${key}_${lang}`;
        return branding[localizedKey] || branding[`${key}_en`] || '';
    };

    return (
        <BrandingContext.Provider value={{ branding, loading, currentLang, setLang, refreshBranding: fetchBranding, t }}>
            {children}
        </BrandingContext.Provider>
    );
};

export const useBranding = () => {
    const context = useContext(BrandingContext);
    if (!context) {
        throw new Error('useBranding must be used within a BrandingProvider');
    }
    return context;
};
